import { render } from "./CustomerRateForm.vue?vue&type=template&id=52c1396f"
import script from "./CustomerRateForm.vue?vue&type=script&lang=js"
export * from "./CustomerRateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__